module.exports = __webpack_public_path__ + "static/media/How can I link more than one applicant in a Visa case.bbd3b766.png";